const sectionId = document.currentScript.getAttribute('data-section-id');
const product_form_id = document.currentScript.getAttribute('data-product-form-id');
const isCorperateProduct = document.currentScript.getAttribute('data-is-corporate-product');
const form = document.querySelector('.product-form form');
const submitButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
const errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
const errorMessage = document.querySelector('.product-form__error-message');
const radioButtons = document.querySelectorAll('.unicef-form__input--rectangle input[type="radio"]');
const cardSelector = document.getElementById('Slider-{{ section.id }}');
const inputField = document.getElementById('custom_gift_card_variant');
const detailInput = document.querySelector('.detail-input')

function fadeElements(elements, fadeIn) {
    return Promise.all(elements.map(element => {
        return new Promise(resolve => {
            element.style.opacity = fadeIn ? '1' : '0'
            setTimeout(() => {
                resolve();
            }, 300)
        })
    }))
}

function slideElements(elements, slideDown) {
    return Promise.all(elements.map(element => {
        return new Promise(resolve => {
            const height = element.scrollHeight
            // element.style.overflow = 'hidden'
            if (slideDown) {
                element.style.maxHeight = '0px'
                setTimeout(() => {
                    element.style.maxHeight = height + 'px'
                }, 10);
            } else {
                element.style.maxHeight = height + 'px'
                setTimeout(() => {
                    element.style.maxHeight = '0px'
                }, 10);
            }
            setTimeout(() => {
                if (slideDown) {
                    element.style.maxHeight = 'none'
                }
                resolve();
            }, 500);
        })
    }))
}

const setDisabled = (elements, isDisabled) => {
    elements.forEach(el => el.disabled = isDisabled);
}

async function updateCover(cover, shouldHide, visible) {
    if ((!shouldHide && visible) || (shouldHide && !visible)) return
    if (!shouldHide) {
        cover.style.display = 'contents'
        await slideElement(cover, true)
        await fadeElement(cover, true)
        cover.dataset.visible = 'shown'
    } else {
        await fadeElement(cover, false)
        await slideElement(cover, false)
        cover.style.display = 'none'
        cover.dataset.visible = 'hidden'
    }
}

async function updateUI(selectedValue) {

    radioButtons.forEach(button => button.disabled = true)
    const currentMethod = detailInput.dataset.method
    
    const pdfCovers = document.querySelectorAll('div[data-cover="pdf"]')
    const nocardCovers = document.querySelectorAll('div[data-cover="no-card"]')
    const pdfCoverInputs = [...pdfCovers].map(cover => [...cover.querySelectorAll('input, textarea')]).flat()
    const nocardCoverInputs = [...nocardCovers].map(cover => [...cover.querySelectorAll('input, textarea')]).flat()

    switch (currentMethod) {
        case 'email':
            if (selectedValue === 'Printable PDF') {
                await fadeElements([...pdfCovers], false)
                await slideElements([...pdfCovers], false)
                pdfCovers.forEach(cover => cover.style.display = 'none')
                detailInput.dataset.method = 'pdf'
                setDisabled(nocardCoverInputs, false)
                setDisabled(pdfCoverInputs, true)
            } else {
                await fadeElements([...nocardCovers], false)
                await slideElements([...nocardCovers], false)
                nocardCovers.forEach(cover => cover.style.display = 'none')
                detailInput.dataset.method = 'no-card'
                setDisabled(nocardCoverInputs, true)
            }
            break
        case 'pdf':
            if (selectedValue === 'Email') {
                setDisabled(nocardCoverInputs, false)
                setDisabled(pdfCoverInputs, false)
                pdfCovers.forEach(cover => cover.style.display = '')
                await slideElements([...pdfCovers], true)
                await fadeElements([...pdfCovers], true)
                detailInput.dataset.method = 'email'
            } else {
                await fadeElements([...nocardCovers], false)
                await slideElements([...nocardCovers], false)
                nocardCovers.forEach(cover => cover.style.display = 'none')
                pdfCovers.forEach(cover => cover.style.display = '')
                pdfCovers.forEach(cover => cover.style.opacity = '1')
                pdfCovers.forEach(cover => cover.style.maxHeight = 'none')
                await fadeElements([...pdfCovers], true)
                detailInput.dataset.method = 'no-card'
                setDisabled(nocardCoverInputs, true)
            }
            break
        case 'no-card':
            if (selectedValue === 'Email') {
                setDisabled(nocardCoverInputs, false)
                pdfCovers.forEach(cover => cover.style.display = '')
                nocardCovers.forEach(cover => cover.style.display = '')
                await slideElements([...nocardCovers], true)
                await fadeElements([...nocardCovers], true)
                detailInput.dataset.method = 'email'
            } else {
                setDisabled(nocardCoverInputs, false)
                setDisabled(pdfCoverInputs, true)
                pdfCovers.forEach(cover => cover.style.display = 'none')
                pdfCovers.forEach(cover => cover.style.opacity = '0')
                pdfCovers.forEach(cover => cover.style.maxHeight = '0px')
                nocardCovers.forEach(cover => cover.style.display = '')
                await slideElements([...nocardCovers], true)
                await fadeElements([...nocardCovers], true)
                detailInput.dataset.method = 'pdf'
            }
            break
    }

    radioButtons.forEach(button => button.disabled = false)
}

// async function updateCorporateUI(selectedValue) {

//     radioButtons.forEach(button => button.disabled = true)

//     const currentMethod = detailInput.dataset.method

//     switch (currentMethod) {
//         case 'email':
//             if (selectedValue === 'Printable PDF') {
//                 await fadeElement(covers['pdf'], false)
//                 await slideElement(covers['pdf'], false)
//                 covers['pdf'].style.display = 'none'
//                 detailInput.dataset.method = 'pdf'
//                 setDisabled(pdfCoverInputs, true)
//             } else {
//                 await fadeElement(covers['no-card'], false)
//                 await slideElement(covers['no-card'], false)
//                 covers['no-card'].style.display = 'none'
//                 detailInput.dataset.method = 'no-card'
//                 setDisabled(nocardCoverInputs, true)
//             }
//             break
//         case 'pdf':
//             if (selectedValue === 'Email') {
//                 setDisabled(pdfCoverInputs, false)
//                 covers['pdf'].style.display = 'block'
//                 await slideElement(covers['pdf'], true)
//                 await fadeElement(covers['pdf'], true)
//                 detailInput.dataset.method = 'email'
//             } else {
//                 await fadeElement(covers['no-card'], false)
//                 await slideElement(covers['no-card'], false)
//                 covers['no-card'].style.display = 'none'
//                 covers['pdf'].style.display = 'block'
//                 covers['pdf'].style.opacity = '1'
//                 covers['pdf'].style.maxHeight = 'none'
//                 await fadeElement(covers['pdf'], true)
//                 detailInput.dataset.method = 'no-card'
//                 setDisabled(nocardCoverInputs, true)
//             }
//             break
//         case 'no-card':
//             if (selectedValue === 'Email') {
//                 setDisabled(nocardCoverInputs, false)
//                 covers['pdf'].style.display = 'block'
//                 covers['no-card'].style.display = 'block'
//                 await slideElement(covers['no-card'], true)
//                 await fadeElement(covers['no-card'], true)
//                 detailInput.dataset.method = 'email'
//             } else {
//                 setDisabled(pdfCoverInputs, false)
//                 covers['pdf'].style.display = 'none'
//                 covers['pdf'].style.opacity = '0'
//                 covers['pdf'].style.maxHeight = '0px'
//                 covers['no-card'].style.display = 'block'
//                 await slideElement(covers['no-card'], true)
//                 await fadeElement(covers['no-card'], true)
//                 detailInput.dataset.method = 'pdf'
//             }
//             break
//     }

//     radioButtons.forEach(button => button.disabled = false)
// } 
     
function isValidInput(input) {

    if (input.disabled) return true

    if (input.id.includes("email")) {
        const emailRegex = /^[\w.!#$%&'*+/=?^`{|}~-]+(?:\.[\w.!#$%&'*+/=?^`{|}~-]+)*@[\w-]+(?:\.[\w-]+)+$/
        return emailRegex.test(input.value.trim()) || "Please check email address."
    } else if (input.id.includes("custom-gift-delivery-date")) {
        const inputDate = new Date(input.value).setHours(0, 0, 0, 0)
        const today = new Date().setHours(0, 0, 0, 0)
        return inputDate >= today || "Please select a date today or in the future."
    } else {
        return input.value.trim() !== '' || "Please fill in all fields."
    }
} 

function handleSubmit(event) {
    clearErrorMessages();
    // Perform validation checks
    const inputs = document.querySelectorAll('.unicef-form-elements .form__input');

    inputs.forEach(input => {
        if (input.value && (input.type === 'text' || input.type === 'email')) {
            input.value = input.value.trim()
        }
    })

    const isValid = Array.from(inputs).filter(input => input != null).map(isValidInput)

    if (!isValid.every(input => input === true)) {
        event.preventDefault();
        const errorMessage = [...new Set(isValid.filter(r => typeof r === 'string'))].join(' ')
        showErrorMessage(errorMessage);
    }
}

function clearErrorMessages() {
    errorMessageWrapper.hidden = true;
    errorMessage.textContent = '';
}

function showErrorMessage(message) {
    errorMessageWrapper.hidden = false;
    errorMessage.textContent = message;
}

function handleRadioChange() {
    const selectedRadio = document.querySelector('.unicef-form__input--rectangle input[type="radio"]:checked');
    const selectedValue = selectedRadio ? selectedRadio.value : null;
    // if(isCorperateProduct==="true") {
    //         updateCorporateUI(selectedValue);
    //     } else {
    //     updateUI(selectedValue);// Update UI based on radio selection
    // } 
    updateUI(selectedValue)
}

/**
 * listen for form submission and radio button changes
 */
document.addEventListener('DOMContentLoaded', function () {
    // updateUI(selectedValue);
    form.addEventListener('submit', (event) => handleSubmit(event));
    radioButtons.forEach(radio => {
        radio.addEventListener('change', () => handleRadioChange());
    });
    
});

/**
 * Option 4: Replace the button with a dummy element, log clicks, run validation, and execute the original button's function
 */
function ReplaceButtonWithDummy() {
    const shopifyButtonWrapper = document.getElementById('shopify-accelerated-checkout-wrapper');
    if (shopifyButtonWrapper) {
        const shopifyPaymentButton = shopifyButtonWrapper.querySelector('.shopify-payment-button__button.shopify-payment-button__button--unbranded');
        if (shopifyPaymentButton) {
            const dummyButton = document.createElement('div');
            dummyButton.textContent = 'Buy it now';
            dummyButton.className = shopifyPaymentButton.className;
            dummyButton.style.cursor = 'pointer'; // Ensure it looks clickable
            shopifyPaymentButton.parentNode.replaceChild(dummyButton, shopifyPaymentButton);

            // Add a click event listener to the dummy button
            dummyButton.addEventListener('click', (event) => {
                clearErrorMessages();

                const inputs = document.querySelectorAll('.unicef-form-elements .form__input');
                inputs.forEach(input => {
                    if (input.value && (input.type === 'text' || input.type === 'email')) {
                        input.value = input.value.trim();
                    }
                });

                const isValid = Array.from(inputs).filter(input => input != null).map(isValidInput);

                if (!isValid.every(input => input === true)) {
                    event.preventDefault();
                    const errorMessage = [...new Set(isValid.filter(r => typeof r === 'string'))].join(' ');
                    showErrorMessage(errorMessage);
                } else {
                    shopifyPaymentButton.disabled = false; // Ensure the button is enabled
                    shopifyPaymentButton.click(); // Programmatically trigger the original button's click event
                }
            });

        }
    }
}


ReplaceButtonWithDummy();